import { useEffect, useState } from 'react';
import { useStoreState } from 'base/store';

type IProps = {
    isGift?: boolean;
    isSuperFlashSale?: boolean;
    isFlashSale?: boolean;
}

export type useFlashSaleActivityProps = {
    icon?: string;
    text?: string;
    listPage?: {
        titleImageUrl?: string
    }
}

export const flashSaleConfig = {
    gift: {
        text: 'web_tag_winter_sale',
        listPage: {
            titleImageUrl: 'asset/width-720/picture/cae4cbf6840895e0bfe760e6afddad62.jpg'
        },
    },
    primeDay: {
        text: 'web_tag_prime_day',
        icon: 'icon-a-flashsale',
        listPage: {
            titleImageUrl: 'asset/width-720/picture/f5518a6a46a0ba818ed1020fa4adaf64.png'
        },
    },
    blackFriday: {
        text: 'web_tag_black_friday',
        listPage: {
            titleImageUrl: 'asset/width-720/picture/cae4cbf6840895e0bfe760e6afddad62.jpg'
        },
    },
    cyberMonday: {
        text: 'web_tag_cyber_monday',
        listPage: {
            titleImageUrl: 'asset/width-720/picture/d91b8f1e242861b08fa5a00c035d50cd.jpg'
        },
    },
    flashSale: {
        icon: 'icon-a-flashsale',
        text: 'web_tag_flash_sale',
        listPage: {
            titleImageUrl: 'asset/width-720/picture/092ba9ce93f808da23098a6806baaf03.png'
        },
    },
    superFlashSale: {
        icon: 'icon-a-flashsale',
        text: 'web_tag_super_flash_sale'
    }
}

const useFlashSaleActivity = (props?: IProps): useFlashSaleActivityProps => {

    const {
        isSuperFlashSale,
        isFlashSale,
        isGift
    } = props || {}


    // isSuperFlashSale 优先级最高
    let showType = isSuperFlashSale
        ? 'superFlashSale'
        : isGift
            ? 'gift'
            : isFlashSale
                ? 'flashSale'
                : ''

    const targetConfig = flashSaleConfig[showType]

    return {
        ...targetConfig,
    }

};

export default useFlashSaleActivity